import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import userApi from '../../api/user.js'

export interface RootState {
    version: string;
}
const getGroupNames = ({ products, locations, userType }: { products: string[]; locations: number[]; userType: string; }) => {
    const groups: string[] = [];
    if (userType == "SuperAdmin" || userType == "LH") {
        groups.push(userType);
        return groups;
    }

    if (userType == "CLP") {
        products.forEach((e: string) => {
            groups.push(`${e}_${userType}`);
        });
        return groups;
    }

    locations.forEach((s: number) => {
        products.forEach((e: string) => {
            groups.push(`${s}_${e}_${userType}`);
        });

    });
    return groups;
}

export class user {
    userId: number | undefined;
    expire: number | undefined;
    username: "" | undefined;
    token: "" | undefined;
    userType: string | undefined;
    isLoggedin: boolean | undefined;
    message: string | undefined;
    menu: boolean | undefined;
    groupName: Array<string> | undefined;
    access: Array<access> | undefined;
    accessLevel: number | undefined;
    products: Array<string> | undefined;
    locationId: number | undefined;
    sourceLocations: Array<number> | undefined;
}

export class userState {
    user: user = new user;
    snackbar: snackbar = new snackbar;
    serviceLoader = false;
    logo!: string;
    menu!: boolean;
}

export class snackbar {
    show = false;
    message: string | undefined;
    color!: string;
}

export class access {
    name: string | undefined;
    actions: Array<string> | undefined;
}


const state = {
    user: { isLoggedin: false, message: "", },
    snackbar: { show: false, message: "", color: "" },
    serviceLoader: false,
    logo: "",
    menu: true,

};
const getters: GetterTree<userState, RootState> = {
    user(state: userState) {
        return state.user
    },
    snackbar(state: userState) {
        return state.snackbar
    },
    serviceLoader(state: userState) {
        return state.serviceLoader
    },
    logo(state: userState) {
        return state.logo
    },
};
export const mutations: MutationTree<userState> = {
    LOAD_USER(state: userState, user: user) {
        state.user = user
    },
    CLEAR_USER(state: userState) {
        state.user = new user
    },
    SHOW_MESSAGE(state: userState, snackbar: snackbar) {
        state.snackbar = snackbar
    },
    SHOW_LOADER(state: userState, serviceLoader: boolean) {
        state.serviceLoader = serviceLoader
    },
    LOAD_LOGO(state: userState, logo: string) {
        state.logo = logo
    },
    SHOW_MENU(state: userState, show: boolean) {
        state.user.menu = show
        state.menu = show;
    }
};
const actions: ActionTree<userState, RootState> = {
    showServiceLoader({ commit }: { commit: Commit }, flag: boolean): void {
        commit('SHOW_LOADER', flag)
    },
    showMenu({ commit }: { commit: Commit }, flag: boolean): void {
        commit('SHOW_MENU', flag)
    },
    resetMessage({ commit }: { commit: Commit }): void {
        commit('SHOW_MESSAGE', { show: false, message: "", color: "" })
    },
    showMessage({ commit }: { commit: Commit }, message: string): void {
        commit('SHOW_MESSAGE', { show: true, message: message, color: "success" })
    },
    showValidationMessage({ commit }: { commit: Commit }, payload: snackbar): void {
        commit('SHOW_MESSAGE', { show: true, message: payload.message, color: payload.color })
    },
    checkUserAccess({ state }: { state: userState }, params: string[]):  boolean {
        const userAccess = state.user.access;
        const module = userAccess?.find(e => e.name == params[0]);
        if (!module) return false;
        const action = module.actions?.find(e => e == params[1] || e == "ALL");
        if (!action) return false;
        return true;
    },
    async login({ state, commit }: { commit: Commit, state: userState }, params: string[]): Promise<void> {
        if (!state.user.isLoggedin) {
            commit('SHOW_LOADER', true)
            try {

                const response = await userApi.login(params[0], params[1])
                if (response && response.data && response.data.resultType === 200) {

                    const u = {
                        userId: response.data.payload.userId,
                        username: response.data.payload.username,
                        expire: response.data.payload.expire,
                        token: response.data.payload.token,
                        userType: response.data.payload.userType,
                        isLoggedin: true,
                        access: response.data.payload.access,
                        products: response.data.payload.products,
                        locationId:response.data.payload.locationId,
                        sourceLocations: response.data.payload.sourceLocations,
                        accessLevel: response.data.payload.accessLevel,
                        groupName: getGroupNames({
                            products: response.data.payload.products,
                            locations: [response.data.payload.locationId],
                            userType: response.data.payload.userType
                        })
                    }
                    localStorage.setItem("token", response.data.payload.token);
                    commit('LOAD_USER', u)
                }
                else {
                    commit('LOAD_USER', {
                        "isLoggedin": false,
                        "message": "Invalid username and password"
                    })
                }
                commit('SHOW_LOADER', false)
            }
            catch (error) {
                commit('SHOW_LOADER', false)
                state.user.isLoggedin = false
            }
        }
    },
    async logout({ commit }: { commit: Commit }) {
        commit('LOAD_USER', {
            "isLoggedin": false,
            message: ""
        })
        commit('CLEAR_NOTIFICATION')

    }
}
export default {
    state,
    getters,
    mutations,
    actions
}